module.exports = __webpack_public_path__ + "img/icon_menu2.2f935d5d.jpg";